import PlanYourStayModule from './PlanYourStayModule';

export default PlanYourStayModule;
